<div class="modal-header">
  <h5 class="modal-title" id="configuration-confirm-title">
    <i class="fa fa-exclamation-triangle me-2"></i>Confirmar alteração de cobrança
  </h5>
  <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" aria-label="Fechar" (click)="cancel()"
    data-testid="btn-confirm-close">
    <i class="fa fa-times"></i>
  </button>
</div>

<div class="modal-body" data-testid="confirm-billing-body">
  <p class="confirm-lead">
    <strong>{{ configuration.label }}</strong> é uma configuração de cobrança: mudar o valor altera
    quanto e como os clientes são cobrados. É uma ação de dinheiro.
  </p>

  <dl class="confirm-change">
    <div>
      <dt>Em vigor</dt>
      <dd data-testid="confirm-current">{{ currentLabel }}</dd>
    </div>
    <div>
      <dt>Novo valor</dt>
      <dd data-testid="confirm-next">{{ nextLabel }}</dd>
    </div>
  </dl>

  <p class="confirm-note">
    <code>{{ configuration.key }}</code> passa a valer para o sistema em até
    {{ propagationSeconds }} segundos, e a alteração fica registrada no histórico com o seu usuário.
  </p>
</div>

<div class="modal-footer">
  <button type="button" class="sf-btn sf-btn--secondary" (click)="cancel()" data-testid="btn-confirm-cancel">
    Cancelar
  </button>
  <button type="button" class="sf-btn sf-btn--primary" (click)="confirm()" data-testid="btn-confirm-save">
    Confirmar e salvar
  </button>
</div>
